import { setApiLocale } from '@/api/core'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import enAccounting from './locales/en-accounting.json'
import enAdmin from './locales/en-admin.json'
import enAuth from './locales/en-auth.json'
import enCopilot from './locales/en-copilot.json'
import enCrm from './locales/en-crm.json'
import enCustoms from './locales/en-customs.json'
import enExpenses from './locales/en-expenses.json'
import enFinance from './locales/en-finance.json'
import enFleet from './locales/en-fleet.json'
import enFreight from './locales/en-freight.json'
import enHr from './locales/en-hr.json'
import enLearn from './locales/en-learn.json'
import enPayroll from './locales/en-payroll.json'
import enSettings from './locales/en-settings.json'
import enShipments from './locales/en-shipments.json'
import enSuppliers from './locales/en-suppliers.json'
import enWarehouse from './locales/en-warehouse.json'
import enWorkspaces from './locales/en-workspaces.json'
import en from './locales/en.json'
import frAccounting from './locales/fr-accounting.json'
import frAdmin from './locales/fr-admin.json'
import frAuth from './locales/fr-auth.json'
import frCopilot from './locales/fr-copilot.json'
import frCrm from './locales/fr-crm.json'
import frCustoms from './locales/fr-customs.json'
import frExpenses from './locales/fr-expenses.json'
import frFinance from './locales/fr-finance.json'
import frFleet from './locales/fr-fleet.json'
import frFreight from './locales/fr-freight.json'
import frHr from './locales/fr-hr.json'
import frLearn from './locales/fr-learn.json'
import frPayroll from './locales/fr-payroll.json'
import frSettings from './locales/fr-settings.json'
import frShipments from './locales/fr-shipments.json'
import frSuppliers from './locales/fr-suppliers.json'
import frWarehouse from './locales/fr-warehouse.json'
import frWorkspaces from './locales/fr-workspaces.json'
import fr from './locales/fr.json'

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        common: fr,
        auth: frAuth,
        settings: frSettings,
        shipments: frShipments,
        finance: frFinance,
        customs: frCustoms,
        expenses: frExpenses,
        warehouse: frWarehouse,
        accounting: frAccounting,
        hr: frHr,
        payroll: frPayroll,
        admin: frAdmin,
        workspaces: frWorkspaces,
        crm: frCrm,
        suppliers: frSuppliers,
        fleet: frFleet,
        freight: frFreight,
        learn: frLearn,
        copilot: frCopilot,
      },
      en: {
        common: en,
        auth: enAuth,
        settings: enSettings,
        shipments: enShipments,
        finance: enFinance,
        customs: enCustoms,
        expenses: enExpenses,
        warehouse: enWarehouse,
        accounting: enAccounting,
        hr: enHr,
        payroll: enPayroll,
        admin: enAdmin,
        workspaces: enWorkspaces,
        crm: enCrm,
        suppliers: enSuppliers,
        fleet: enFleet,
        freight: enFreight,
        learn: enLearn,
        copilot: enCopilot,
      },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'settings',
      'shipments',
      'finance',
      'customs',
      'expenses',
      'warehouse',
      'accounting',
      'hr',
      'payroll',
      'admin',
      'workspaces',
      'crm',
      'suppliers',
      'fleet',
      'learn',
      'copilot',
    ],
    interpolation: { escapeValue: false },
    detection: {
      // Project is FR-first (DEFAULT_LOCALE=fr) and many pages still ship
      // hardcoded French strings. Trust only an explicit user choice in
      // localStorage, otherwise fall back to `fr` — never auto-switch to EN
      // because the browser navigator happens to be English.
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  })
  .then(() => {
    setApiLocale(i18n.language.startsWith('fr') ? 'fr' : 'en')
  })

i18n.on('languageChanged', (lng) => {
  setApiLocale(lng.startsWith('fr') ? 'fr' : 'en')
})

export default i18n
